import axios from 'axios';
import {req, getByobj, postobj} from './axiosFun';

/**
 * 订单管理-交易订单
 **/
// 交易订单-获取交易订单列表
export const OrderList = (params) => { return getByobj("get", "/order/listByPage", params) };
export const OrderListOfChild = (params) => { return getByobj("get", "/order/listByPageOfChild", params) };
// 交易订单-编辑交易订单
export const OrderUpdate = (params) => { return req("post", "/order/update", params) };

// 订单编辑--快递公司下拉列表
export const findExpreCompany = () => { return req("get", "/order/findExpreCompany") };

// 交易订单-s删除交易订单
export const OrderDelete = (params) => { return axios.delete("/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 交易订单-交易订单退款
export const OrderRefund = (params) => { return getByobj("get", "/refundrecord/listByPage", params) };
// 交易订单-交易订单退款审核
export const auditOrder = (params) => { return req("post", "/refundrecord/audit", params) };
// 交易订单-交易订单确认收货
export const confirm = (params) => { return req("post", "/refundrecord/confirm", params) };
// 交易订单-交易订单重推
export const customdeclareredeclare = (params) => { return req("post", "/order/customdeclareredeclare?id="+params) };
//虚拟订单新增
export const addFakeOrder = (params) => { return postobj("post", "/fakeOrderMsg/add", params) };
//虚拟订单列表查询
export const fakeOrderList = (params) => { return getByobj("get", "/fakeOrderMsg/list", params) };
//虚拟订单详情
export const getFakeOrder = (id) => { return getByobj("get", "/fakeOrderMsg/"+id) };
//修改虚拟订单信息
export const editFakeOrder = (params) => { return postobj("post", "/fakeOrderMsg/edit", params) };
//删除虚拟订单
export const delFakeOrder = (ids) => { return getByobj("post", "/fakeOrderMsg/"+ids) };
//获取虚拟订单轮播频率
export const getTimer = (params) => { return getByobj("get", "/fakeOrderMsg/getTimer", params) };
//修改虚拟订单轮播频率
export const editTimer = (params) => { return postobj("post", "/fakeOrderMsg/editTimer", params) };



// WEBPACK FOOTER //
// ./src/api/payMG.js